module.exports = __webpack_public_path__ + "img/logo.4ef2444c.png";